import { BinderNote } from "@/models/binder.model";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-notes-column',
    template: `
    <div [innerHTML]="lastNote?.Note"></div>
    `,
    standalone: true,
    imports: [
    ],
    styles: [
        `
        `
    ]
})

export class NotesColumnComponent {
@Input() value: BinderNote[] = [];

get lastNote(): BinderNote | null {
    if(this.value.length > 0){
        return this.value.sort((a, b) => new Date(b.CreatedOn).getTime() - new Date(a.CreatedOn).getTime())[0];
    }
    return null;
}
}